window.sfDocumentReady(['route-login'], function () {
  toggleLoginType()

  $("#magicForm").on('submit', function (e) {
    e.preventDefault();
    generateMagicLink()
  });

  $('#loginForm').on('submit', function() {
    $(this).find('.btn-login').prop('disabled', true);
  });

  function generateMagicLink() {
    $('.js-login-pw').val('')
    const data = $('#magicForm').serialize()
    window.httpPost('/login/generate', data, {
      success(data) {
        if (data.status === 'success') {
          notifyBox(
            'Success: Magic Link',
            'A magic link has been generated and sent to you by email',
            'success'
          );
        } else {
          notifyBox(
            'Error: Magic Link',
            'Email authentication failed. Please try again...',
            'error'
          );
        }
      }
    });
  };

  function toggleLoginType() {
    $('.js-toggle-login-type').on('click', function () {
      const type = $(this).attr('href').replace('#', '')
      $('.js-login-pw').val('')
      $('.js-login-type').removeClass('sf-hidden')
      $(`.js-login-${type}`).addClass('sf-hidden')
    })
  }

  switch (window.location.hash) {
    case '#magic-link':
    case '#password':
      $(`a[href="${window.location.hash}"].js-toggle-login-type`).trigger('click')
      break;
    default:
      $(`a[href="#magic-link"].js-toggle-login-type`).trigger('click')
  }

  $('.js-email').trigger('focus')
});
